<div>
    <mat-toolbar color="primary" style="margin-bottom: 5px;">
      <mat-toolbar-row>
        <div fxShow="true" *ngIf="this.isAuthenticated">
          <button
            mat-icon-button
            (click)="clickMenu()"
            fxShow
          >
            <mat-icon>menu</mat-icon>
          </button>
        </div>
        <mat-label fxShow fxHide.lt-md style="margin-left: 15px;"> {{ 'header.title' | translate }} </mat-label>
        <mat-label fxShow fxHide.gt-sm  style="margin-left: 5px;"> {{ 'header.title-short' | translate }} </mat-label>
        <div fxFlex  fxLayoutAlign="flex-end center">
          <div fxFlex *ngIf="isAuthenticated && menuItems.length === 0" >
            {{ userName }}
          </div>
          <div fxFlex  fxLayoutAlign="flex-end center">
            <button mat-button [matMenuTriggerFor]="menu" *ngIf="isAuthenticated && menuItems.length > 0" style="font-size: 20px;">{{ userName }}</button>
              <mat-menu #menu="matMenu">
                  <div fxLayout="column" *ngFor="let itemMenu of menuItems">
                    <a fxLayout="row" [routerLink]=itemMenu.menuRouterLink [ngClass]=itemMenu.style (mouseenter)="mouseEnter(itemMenu)" (mouseleave)="mouseLeave(itemMenu)">
                      <mat-label class="menu-item">{{ itemMenu.menuTitle }}</mat-label>
                  </a>
                  </div>
                  <a fxLayout="row" (mouseenter)="mouseEnterLogout()" (mouseleave)="mouseLeaveLogout()" (click)="onLogout()" [ngClass]=itemStyle>
                    <mat-label class="menu-item">{{ logoutHeader }}</mat-label>
                </a>
              </mat-menu>
          </div>        
        </div>
      </mat-toolbar-row>
    </mat-toolbar>
    <app-sidenav [userName]=userName></app-sidenav>
  </div>
